/**
 * DS-02 Hedging density (INV-CH-DS-02; kept). Two-way: the seed's left clamp is kept.
 *
 * Events: HEDGES words (may, might, could, arguably, …) per 1k prose words, over the seed's
 * tokenizer (word set). Ramp: the seed's, verbatim.
 */
import {
	Tally,
	compiledEnglish,
	line,
	nativeMeasure,
	proseBlocks,
	rateDef,
	wordExposure,
} from './a-shared.ts';
import { makeEvidence, rateChannel } from './framework.ts';
import type { ChannelImpl, Measurement, RunContext } from './types.ts';

export const ds02Def = rateDef({
	id: 'DS-02',
	name: 'Hedging density',
	family: 'VOCAB',
	features: [{ id: 'hedge', label: 'Hedge word' }],
	oneWay: false,
	minExposure: 400,
	exposureUnit: 'words',
	lang: 'native',
	ramp: [
		[5, 15],
		[15, 32],
		[28, 52],
		[45, 70],
		[70, 84],
	],
	unitScale: 1000,
	unitLabel: 'hedges per 1k words',
	phi0: 1.5,
	weight: 0.6,
	nd: 1,
	changes: [],
});

function measure(ctx: RunContext): Measurement {
	const { doc } = ctx;
	const lex = compiledEnglish();
	const k = new Float64Array(doc.paragraphs.count);
	const e = wordExposure(doc);
	const ev = makeEvidence();
	const hits = new Tally();
	for (const b of proseBlocks(doc)) {
		lex.hedges.scan(b.text, b.base, (s, en, w) => {
			k[b.p] = (k[b.p] as number) + 1;
			ev.add(s, en, 0, 1);
			hits.add(w);
		});
	}
	const summary = hits.top(8).map(([w, n]) => line(w, `${n}×`));
	return { k, e, evidence: ev, summary };
}

export const ds02: ChannelImpl = rateChannel(ds02Def, nativeMeasure(measure));
export { ds02Def as def, ds02 as impl };
